import React, {Component} from 'react';
import {Popup} from 'semantic-ui-react';

class PartInfo extends Component {
  render() {
    const {partCode, partName} = this.props;
    
    if (!partName) {
      return partCode;
    }

    return (
      <Popup inverted
        content={partName}
        trigger={<span>{partCode}</span>}
      />
    );
  }
}

export default PartInfo;
